import { observable, action } from 'mobx'

export default class MyBetsStore {
  defaultFilter = {
    statusSelected: 'OPEN',
    prodTypeSelected: 'ALL',
    daySelected: -1,
    sportIds: [],
    leagueIds: [],
    previousFilter: {
      sportIds: [],
      leagueIds: [],
    },
  }

  @observable productInQuery = [];

  @observable selectedData = this.defaultFilter;

  @observable dataFilterWagger = [];
  
  @observable showFilterOptions = true;

  @observable enabledFilterOptions = false;

  @observable filterOptions = {};

  @action updateData(newData) {
    this.selectedData = newData
  }
  @action updateProductInQuery(newData) {
    this.productInQuery = newData
  }
  @action updateDataFilterWagger(newData) {
    this.dataFilterWagger = newData
  }
  @action updateShowFilterOptions(value) {
    this.showFilterOptions = value
  }
  @action updateEnabledFilterOptions(value) {
    this.enabledFilterOptions = value
  }
  @action updateFilterOptions(newData) {
    this.filterOptions = newData
  }
  @action resetFilterSportsLeagues() {
    this.selectedData = {
      ...this.selectedData,
      sportIds: [],
      leagueIds: [],
      previousFilter: {
        sportIds: [],
        leagueIds: [],
      },
    }
  }

  @action resetDateFilterOptions() {
    this.selectedData.daySelected = -1
  }
}



// WEBPACK FOOTER //
// ./src/app/stores/MyBetsStore.js